import _                      from '_';
import Reflux                 from 'reflux';
import DescriptorStore        from 'stores/descriptor_store';


export default  Reflux.createStore({
  canShowBoth: false,
  init() {
    this.listenTo(DescriptorStore, 'onLoad');
  },
  onLoad(state) {
    const videos = _.get(state, 'descriptor.videos', [ ]);
    this.canShowBoth = videos.length > 1;
  }
});



// WEBPACK FOOTER //
// ./modules/stores/brand_play_layout_store.js